import * as UIUtil from "/app/js/util/UI.js";
import * as Menu from "/app/js/common/Menu.js";
import * as Simple from "/app/js/panel/Simple.js";
import * as Footer from "./Footer.js";
import * as Header from "./Header.js";

export const init = async function () {



    document.querySelectorAll('.swiper-wrapper .swiper-item').forEach(function (el, index) {

        el.addEventListener('click', async function () {
            const menuKeys = ["SiSm", "Database", "RndConsulting", "Overseas"];
            const menuKey = menuKeys[index];

            if (menuKey === 'Main') {
                UIUtil.clearPage(true);
            } else {
                UIUtil.clearPage(false);
            }
            try {
                await Header.init();

                if (menuKey) {
                    await open(menuKey);
                } else {
                    // console.log("Error: Invalid menu key.");
                }

                await Footer.init();
            } catch (error) {
                console.error('Error during navigation:', error);
            }
        })
    });
//finish this part
    document.querySelectorAll('.contents .btn-more').forEach(function (el, index) {
        // const parentKey = "product";
        el.addEventListener('click', async function () {
            const menuKeys = ["Engine", "Lbs", "Utilization"];
            const menuKey = menuKeys[index];

            if (menuKey === 'Main') {
                UIUtil.clearPage(true);
            } else {
                UIUtil.clearPage(false);
            }
            try {
                await Header.init();

                if (menuKey) {
                    await open(menuKey);
                } else {
                    // console.log("Error: Invalid menu key.");
                }

                await Footer.init();
            } catch (error) {
                console.error('Error during navigation:', error);
            }
        })

    });
}

export async function open(menuKey) {

    const lan = document.documentElement.lang;
    const parentKey = Menu.getParentKey(menuKey);
    const htmlUrl = `app/html/${lan}/${parentKey}/${menuKey}.html`;
    // .headerWrap의 다음에 htmlUrl를 fetch하여 삽입한다.

    try {
        const response = await fetch(htmlUrl);
        const text = await response.text();
        const headerWrap = document.querySelector(".headerWrap");
        await headerWrap.insertAdjacentHTML('afterend', text);

        initEvt();
    } catch (error) {
        console.error('HTML 로딩 중 오류 발생:', error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리하도록 함
    }
    // await Footer.init();
}



export function initEvt() {
    const homeElement = document.querySelector('.breadcrumb .home');

    if (homeElement) {
        homeElement.addEventListener('click', () => {
            Menu.openMenu('Main');
        });
    }
}